const home = {
  nav_home: 'Hjem',
  nav_guides: 'Guides',
  nav_reviews: 'Anmeldelser',
  nav_shipping: 'Forsendelse',
  nav_qc: 'QC',
  nav_safety: 'Sikkerhed',
  nav_faq: 'FAQ',
  nav_about: 'Om',
  nav_contact: 'Kontakt',
  nav_article: 'Artikel',
  lang_english: 'English',
  lang_french: 'Français',
  lang_danish: 'Dansk',
  lang_german: 'Deutsch',
  hero_title: 'AllChinaBuy Spreadsheet: Din Komplette Ressource til Køb og Forsendelse',
  hero_subtitle: 'Find, sammenlign og forstå AllChinaBuy-produkter med en praktisk ressource.',
  hero_desc: 'AllChinaBuy Spreadsheet samler produktforskningsressourcer, sælgerinformation, QC-vejledning, forsendelsestip, købsvejledninger og AllChinaBuy-relateret information i ét brugervenligt hub.',
  cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
  cta_secondary: 'Start med Begynderguiden',
  cta_main_site: 'Besøg Hovedwebstedet',
  cta_buy_now: 'Køb Nu',
  trust_text: 'Uafhængig informationsressource • Opdateret regelmæssigt • Bygget til smartere produktforskning',
  section_what_is_title: 'Hvad er AllChinaBuy Spreadsheet?',
  section_what_is_desc: 'AllChinaBuy Spreadsheet er en centraliseret ressource designet til at gøre produktforskning nemmere. Udforsk organiserede produktressourcer, sælgerinformation, QC-vejledning, forsendelsesreferencer og praktiske købsvejledninger fra ét sted.',
  section_resources_title: 'Alt Du Har Brug for til at Forske AllChinaBuy',
  card_spreadsheet_title: 'Spreadsheet',
  card_spreadsheet_desc: 'Udforsk organiserede AllChinaBuy-produkt- og sælgerressourcer.',
  card_shipping_title: 'Forsendelse',
  card_shipping_desc: 'Forstå forsendelsesmetoder, omkostninger og praktiske sammenligningsfaktorer.',
  card_qc_title: 'QC',
  card_qc_desc: 'Lær, hvad du skal kontrollere, før du sender produkter.',
  card_sellers_title: 'Sælgere',
  card_sellers_desc: 'Lær, hvordan du undersøger sælgere og vurderer produktinformation.',
  card_reviews_title: 'Anmeldelser',
  card_reviews_desc: 'Læs uafhængige AllChinaBuy-vejledninger og analyser.',
  card_safety_title: 'Sikkerhed',
  card_safety_desc: 'Lær at identificere mistænkelige links, betalingsanmodninger og almindelige risici.',
  section_categories_title: 'AllChinaBuy Spreadsheet Kategorier',
  section_compare_title: 'Sammenlign Før Du Køber',
  section_compare_desc: 'Forskellige købsplatforme kan have forskellige arbejdsgange, forsendelsesmuligheder og brugeroplevelser. Vores sammenligningsvejledninger hjælper dig med at forstå forskellene, før du træffer en beslutning.',
  cta_view_comparisons: 'Se Alle Sammenligninger',
  section_shipping_title: 'Forsendelse Bør Ikke Være et Gæt',
  section_shipping_desc: 'Forsendelsesomkostninger afhænger af faktorer som destination, pakkens vægt, dimensioner, forsendelsesmetode og aktuelle transportørpriser.',
  cta_explore_shipping: 'Udforsk Forsendelsesvejledninger',
  section_safety_title: 'Bygget Med Sikkerhed i Tankerne',
  section_safety_desc: 'Før du klikker på et produktlink, sender en betaling eller deler personlige oplysninger, skal du kontrollere, hvad du bruger. Vores Sikkerhedscenter forklarer almindelige risici, mistænkelige links, kontosikkerhed og betalingssikkerhed.',
  cta_visit_safety: 'Besøg Sikkerhedscenter',
  section_guides_title: 'Seneste AllChinaBuy Vejledninger',
  section_faq_title: 'Ofte Stillede Spørgsmål',
  faq_q1: 'Hvad er AllChinaBuy Spreadsheet?',
  faq_a1: 'AllChinaBuy Spreadsheet er en uafhængig informationsressource, der organiserer produktforskning, sælgerinformation, forsendelsesvejledninger og købsvejledninger til brugere, der undersøger AllChinaBuy-produkter.',
  faq_q2: 'Er AllChinaBuy legitim?',
  faq_a2: 'AllChinaBuy er en kendt indkøbsagentplatform. Vi leverer uafhængige vejledninger og ressourcer til at hjælpe brugere med at træffe informerede beslutninger.',
  faq_q3: 'Er AllChinaBuy sikker?',
  faq_a3: 'Sikkerhed afhænger af at følge bedste praksis: verificere links, bruge sikre betalingsmetoder, kontrollere sælgeranmeldelser og forstå platformens politikker.',
  faq_q4: 'Hvor meget koster AllChinaBuy-forsendelse?',
  faq_a4: 'Forsendelsesomkostninger varierer efter destination, vægt, dimensioner og forsendelsesmetode. Vores forsendelsesvejledninger forklarer, hvordan du estimerer og sammenligner omkostninger.',
  faq_q5: 'Hvor kan jeg finde AllChinaBuy-kuponer?',
  faq_a5: 'Kuponer og rabatkoder kan være tilgængelige gennem forskellige kanaler. Vi opdaterer vores kuponguide med verificeret information.',
  faq_q6: 'Hvad er AllChinaBuy-lageret?',
  faq_a6: 'Lageret er stedet, hvor produkter opbevares før international forsendelse. At forstå lagerprocesser hjælper dig med at planlægge dine ordrer bedre.',
  faq_q7: 'Hvordan fungerer AllChinaBuy QC?',
  faq_a7: 'Kvalitetskontrol (QC) involverer inspektion af produkter, før de sendes til dig. Vores QC-guide forklarer, hvad du skal kontrollere, og hvordan du anmoder om inspektioner.',
  faq_q8: 'Hvordan bruger jeg et AllChinaBuy-spreadsheet?',
  faq_a8: 'Gennemse kategorier, filtrer efter produkttype, sammenlign sælgere, og brug forsendelsesberegneren til at estimere omkostninger, før du afgiver en ordre.',
  final_cta_title: 'Start Din AllChinaBuy Forskning',
  final_cta_desc: 'Uanset om du undersøger dit første produkt eller sammenligner forsendelses- og sælgermuligheder, start med AllChinaBuy Spreadsheet, og udforsk de vejledninger, der matcher dine behov.',
  footer_disclaimer: 'Dette er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-websted, medmindre det udtrykkeligt er angivet.',
  footer_resources: 'Ressourcer',
  footer_links: 'Links',
  footer_legal: 'Juridisk',
  breadcrumb_home: 'Hjem',
  article_read_more: 'Læs Fuld Guide',
  article_published: 'Udgivet',
  article_updated: 'Sidst Opdateret',
  article_author: 'Forfatter',
  article_related: 'Relaterede Artikler',
  article_sources: 'Kilder',
  article_toc: 'Indholdsfortegnelse',
  dropdown_label: 'Gennemse Kategorier',
  category_button_label: 'Shop',
};

export default home;